export const FeelSubscriptionCommands = {
    FEEL_SUBSCRIPTION_JOIN: '[Feel Subscription] FEEL_SUBSCRIPTION_JOIN',
};
